<template>
  <div class="container">
    <!-- 顶部 -->
    <Nav curNavId="3" pathUrl='plantmoxing' @circle="clickNav" />
    <!-- 内容 -->
    <div class="content">
      <div class="left">
        <!-- 农田介绍 -->
<!--        <Box1 title="轮作制度" :isImg="true" pathName="gbzntjs">-->
<!--            <div class="leftContent1" >-->
<!--            <div class="contentLine contentLine1"></div>-->
<!--            <div class="contentLine contentLine2"></div>-->
<!--            <div class="contentLine contentLine3"></div>-->
<!--            <div class="contentLine contentLine4"></div>-->
<!--&lt;!&ndash;            <div class="leftContent1Left"><img src="../assets/img/plant/img1.jpg" /></div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="leftContent1Right">&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="leftContent1RightTit">高标农田介绍</div>&ndash;&gt;-->
<!--&lt;!&ndash;              &lt;!&ndash; <marquee behavior="scroll" direction="up"  width="100%" height="200px" class="textScroll">{{text}}</marquee> &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="textScroll">&ndash;&gt;-->
<!--&lt;!&ndash;                 <txtScroll>&ndash;&gt;-->
<!--&lt;!&ndash;                  <div v-for="item in textList" :key="item.id" class="scroll_item">&ndash;&gt;-->
<!--&lt;!&ndash;                    {{item}}&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>  &ndash;&gt;-->
<!--&lt;!&ndash;                </txtScroll>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--              <table class="table_b">-->
<!--                <thead>-->
<!--                <tr>-->
<!--                  &lt;!&ndash; 表头行 &ndash;&gt;-->
<!--                  <th v-for="(header, index) in headers" :key="index">-->
<!--                    {{ header }}-->
<!--                  </th>-->
<!--                </tr>-->
<!--                </thead>-->
<!--                <tbody>-->
<!--                &lt;!&ndash; 表体行 &ndash;&gt;-->
<!--                <tr v-for="row in tableData" :key="row.id">-->
<!--                  <td v-for="(cell, index) in row" :key="`${row.id}-${index}`">-->
<!--                    {{ cell }}-->
<!--                  </td>-->
<!--                </tr>-->
<!--                </tbody>-->
<!--              </table>-->
<!--          </div>  -->
<!--        </Box1>-->
        <!-- 种植产品 -->
        <Box1 title="农作物品种" :isImg="true" pathName="plantmoxing">
            <div class="contentLine contentLine1"></div>
            <div class="contentLine contentLine2"></div>
            <div class="contentLine contentLine3"></div>
            <div class="contentLine contentLine4"></div>
            <div class="leftContent2">
              <div class="leftContent2Left">
                <div class="leftContent2LeftTit">农作物</div>
                <div class="leftContent2LeftCon">
                  <img src="../assets/img/plant/left2Left1.png" class="leftContent2LeftConBg" />
                  <div class="icon"><img src="../assets/img/plant/nzw.png"/></div>
                </div>
              </div>
              <div class="leftContent2Right">
                <div class="leftContent2RightItem" v-for="(item,index) in left2Right" :key="index">
                  <div class="leftContent2RightItemLeft"><span>{{item.name}}</span><span>种植面积{{item.area}}万亩</span></div>
                  <div class="icon"><img :src="item.icon" /></div>
                </div>
              </div>
            </div>
        </Box1>
        <!-- 种植类型 -->
        <Box1 title="农作物产量" :isImg="true" pathName="suyuan">
            <div class="leftContent3">
              <div class="leftContent3Item" v-for="(item,index) in left3Data" :key="index">
                <div class="leftContent3Name">
                  <div class="circle">{{item.value}}</div>
                  <div class="circle1"></div>
                  <div class="circle2"></div>
                  <div class="circle3"></div>
                </div>
                <div class="leftContent3Value">{{item.name}}</div>
              </div>
            </div>
        </Box1>
        <Box2 title="农作物面积" :isImg="true" pathName="gbzntjs">
          <div class="leftContent1" >
            <div class="contentLine contentLine1"></div>
            <div class="contentLine contentLine2"></div>
            <div class="contentLine contentLine3"></div>
            <div class="contentLine contentLine4"></div>
            <leftLine/>

          </div>
        </Box2>
      </div>
      <div class="center"></div>
      <div class="right">
        <!-- 智能设备 -->
        <Box1 title="近3年上蔡县种植情况" pathName="plant">
            <!-- <RightSwiper /> -->
            <div class="rightBox1">
              <LeftBar :listData="leftbar" />
              <div class="line"></div>
            </div>
        </Box1>
        <Box1 title="上蔡县小麦育种情况"  pathName="plant">
          <div class="rightBox2">
            <div class="leftBox2Info">
              <div class="txt1Box">
                <div class="txt1Item" v-for="(item,index) in leftTxt1" :key="index">{{item}}</div>
              </div>
              <div class="txt2Box">
                <div class="txt2Item" v-for="(item,index) in leftTxt2" :key="index"><span>{{item.title}}</span><span>{{item.txt}}</span></div>
              </div>
              <div class="txt1Box">
                <div class="txt1Item" v-for="(item,index) in leftTxt3" :key="index">{{item}}</div>
              </div>
            </div>
            <!-- <div class="rightBox2Left">
              <img src="../assets/img/plant/right2Line.png" class="leftLine" />
              <div class="centerList">
                <div class="centerListItem" v-for="(item,index) in rightData2" :key="index">{{item.name}}</div>
              </div>
              <img src="../assets/img/plant/right2Line.png" class="rightLine"/>
            </div> -->
            <!-- <div class="rightBox2Right">
              <div class="videoBox" id="video"><vue3VideoPlay :control="false"  :controlBtns="false" color="#ff0000" width="100%" height="100%" title="冰河世纪" :src="options.src" :type="options.type" :autoPlay="false"  @play="onPlay" /></div>
            </div> -->
<!--            <div style="width:100%;height:100%;" @click="videoClick">-->
<!--              <img src="../assets/img/gbzntyj/video1.jpg" style="width:100%;height:100%;"/>-->
<!--              &lt;!&ndash; <iframe  :src="options.src+AccessToken"  width="100%" height="100%"  id="ysOpenDevice"  allowfullscreen></iframe> &ndash;&gt;-->
<!--            </div>-->
          </div>
        </Box1>
<!--        <Box2 title="雨量趋势"  pathName="qihouYj">-->
<!--          <RightLine/>-->
<!--        </Box2>-->
      </div>
    </div>

  </div>
  <CircleNav :isShow="circleShow"  @closeCircle1="circleHiddlen"  />
  <footer1 />
  <popBg title="高标准农田" :popShow="popShow" @hiddlen="popHiddlen">
    <!-- <vue3VideoPlay id="video"  width="100%"  height="100%"  title="冰河世纪"  :src="videoList[curVideoIndex].options.src"  :type="videoList[curVideoIndex].options.type"  :autoPlay="true"/> -->
    <div style="width: 100%; height: 100%" v-if="AccessToken != ''">
      <iframe
        :src="options.src + AccessToken"
        width="100%"
        height="100%"
        id="ysOpenDevice"
        allowfullscreen
      >
      </iframe>
    </div>
  </popBg>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance
} from "vue";


// import Left1Line from "../components/cangchu/left1Line";
import Nav from "../components/nav.vue";
import Box1 from '../components/plant/Box1.vue'
import Box2 from '../components/plant/Box2.vue'
import RightLine from '../components/plant/RightLine.vue'
import RightSwiper from '../components/plant/RightSwiper.vue'
import leftLine from '../components/plant/leftLine.vue'
import LeftBar from "@/components/plantfx1/leftBar"
import txtScroll from "../components/txtScroll.vue"
import footer1 from "../components/footer.vue";
import popBg from "../components/popBg.vue";
import { useRouter } from 'vue-router'


import { setInterval, clearInterval } from "timers";
import CircleNav from "@/components/circleNav.vue";
export default {
  name: "Home",
  setup() {
    const { proxy } = getCurrentInstance();
    // const timer = ref(null);
    const router = useRouter();
    const state = reactive({
      leftTxt1:["上蔡县共有民办非企业育种单位2个，分别是上蔡县创新农业科学技术研究开发中心和上蔡县亿麦轩小麦研究所。","2018-2023年共有6个小麦新品种获得了国家和省级审定"],
      leftTxt2:[{title:"通过国家审定：",txt:"“轮选禧麦1号” "},{title:"通过河南省审定：",txt:"“轮选88”“ 轮选122”“轮选125” “轮选130”“戚丰5号” "}],
      leftTxt3:["10个品种正在参加国家和省试验","“十四五”期间，将有三个小麦新品种分别通过国家和省级审定。 "],
      options: {
          src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/J57579282/1.live&autoplay=1&accessToken=", //视频源
          type: "m3u8", //视频类型
      },
      currentTime: "",
      navList:[
        {name:"农场概述",path:"",animateShow:false},
        {name:"环境监控",path:"",animateShow:false},
        {name:"设备运维",path:"",animateShow:false},
        {name:"灌溉系统",path:"",animateShow:false}
      ],
      textList:[] ,
      left2Right:[
        {name:"小麦",area:152,icon:require('../assets/img/plant/hs.png')},
        {name:"玉米",area:90,icon:require('../assets/img/plant/ym.png')},
        {name:"花生",area:40.2,icon:require('../assets/img/plant/hs.png')},
      ],
      left3Data:[
        {name:"小麦总产（万吨）",value:82.81},
        {name:"玉米总产（万吨）",value:58.54},
        {name:"花生总产（万吨）",value:12.18},
        {name:"小麦亩产（公斤）",value:544.8},
        {name:"玉米亩产（公斤）",value:646.2},
        {name:"花生亩产（公斤）",value:303}
      ],
      leftbar:{
        time:['2021', '2022', '2023'],
        list:[
          {
            name: '强筋',
            value: [82, 85, 85]
          },
          {
            name: '中筋',
            value: [62, 62, 67]
          },
          {
            name: '弱筋',
            value: [3, 5, 5],
          },
        ]
      },
      rightData:[
        {name:"机井",isLine:600,noLine:0,unit:'眼',icon:require('@/assets/img/plant/zm.png')},
        {name:"水肥一体机",isLine:65,noLine:0,unit:'套',icon:require('@/assets/img/plant/sxt.png')},
        {name:"提灌站",isLine:3,noLine:0,unit:'座',icon:require('@/assets/img/plant/xf.png')},
      ],
      rightData2:[{name:"一号大棚-VR12"},{name:"二号大棚-VR12"},{name:"三号大棚-VR12"},{name:"四号大棚-VR12"},{name:"二号大棚-VR12"},{name:"三号大棚-VR12"},{name:"四号大棚-VR12"}],
      // options:{
      //   src: require("@/assets/video/plant.mp4"), //视频源
      //   type: 'video/mp4', //视频类型
      // }
      AccessToken:"",
      popShow:false,
      circleShow:false,
      headers: ['年份 ╱ 总产', '油菜', '马铃薯','芝麻'], // 表头数据
      tableData: [ // 表格数据
        { id: "2021", 名称: '0.28/万吨', 数量: '1.84/万吨', 数量1: '0.81/万吨' },
        { id: "2022", 名称: '0.27/万吨', 数量: '2.29/万吨', 数量1: '0.84/万吨' },
        { id: "2023", 名称: '0.29/万吨', 数量: '3.45/万吨', 数量1: '0.93/万吨' },


      ],
    });
    onMounted(() => {
      // clearInterval(state.timer.value);
      // state.value = setInterval(() => {
      //   state.currentTime = proxy.$utils.getCurrentTime();
      // }, 1000);
      state.AccessToken = localStorage.getItem('AccessToken')
      // console.log(state.AccessToken )
      // 截取文字
      const text = "上蔡高标农田以高效、节水、智能、绿色、生态为建设目标，将物联网、大数据、云计算与喷灌智能控制系统有机融合，特别是利用北汝河地表水进行灌溉，更符合高效节水灌溉建设要求。项目建成后，将成为一流的物联网、智能化的高效节水灌溉示范区，真正实现“藏粮于地、藏粮于技”，对提高全县农业基础设施建设水平，加快现代农业发展，促进乡村振兴具有重要意义。";
      state.textList = chunkString(text, 37);
       
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
      
    })
    const onPlay = (ev) => {
      console.log('播放')
    }
    function chunkString(str, chunkSize) {
      if (str.length <= chunkSize) {
        return [str];
      }
      return [str.slice(0, chunkSize), ...chunkString(str.slice(chunkSize), chunkSize)];
    }
// 鼠标经过
    function mouseenter(index){
      // let rightData1 = 
      state.navList[index].animateShow = true
    }
    // 鼠标离开
    function mouseleave(index){
      // let rightData1 = 
      state.navList[index].animateShow = false
    }
// 关闭弹出
    function popHiddlen() {
      state.popShow = false;
    }
// 弹出视频
    function videoClick() {
      state.popShow = true;
      // state.curVideoIndex = index;
    }
    function clickNav(isShow){
      // console.log(isShow)
      state.circleShow = isShow.show
    }
    function circleHiddlen(data1){
      // console.log('circle')
      state.circleShow = data1.show
    }

    return {
      ...toRefs(state),
      // timer,
      mouseenter,
      mouseleave,
      // classRight,
      RightSwiper,
      chunkString,
      popHiddlen,
      videoClick,
      clickNav,
      circleHiddlen
    };
  },
  components: {
    CircleNav,
    Nav,
     Box1,
     Box2,
     RightLine,
     RightSwiper,
     txtScroll,
     footer1,
     popBg,
    LeftBar,
    leftLine
  },
};
</script>
<style lang="less" scoped>
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state{
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon{
  font-size: 20px!important;
}
.scrolling-text-container {
  height: 100px; /* 设置容器的高度 */
  overflow: hidden;
}

.scrolling-text-content {
  display: block;
  height: 200%; /* 假设此处为两倍于容器高度 */
  line-height: 1.5; /* 根据实际情况设置行高 */
  white-space: nowrap;
  transform: translateY(0);
}
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("../assets/font/DS-DIGIT.TTF");
}
.container{
  width: 100%;
  height: 100vh;
  background: url("../assets/img/plant/bg1.jpg") no-repeat top center;
  background-size: 100% 100%;
  color: #fff;
  position: relative;
  overflow: hidden;
  // 头部
 .title{
    position: relative;
    width: 100%;
    height: 97px;
    background: url("../assets/img/plant/bt.png") no-repeat top center;
    background-size: 100% 100%!important;
    color: #fff;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .return{
      width: 68px;
      height: 23px;
      cursor: pointer;
      margin-right: 50px;
      // margin-top: 16px;
      position: relative;
      z-index: 999;
    }
    .return:first-child{
      margin-left: 50px;
    }
    .guang1{
      position: absolute;
      top: -36px;
      left: 0;
      animation: titleGuang1 2s linear infinite;
      z-index: 0;
    }
    .guang2{
      position: absolute;
      top: -36px;
      right: 0;
      animation: titleGuang2 2s linear infinite;
    }
    @keyframes titleGuang1{
      0%{
        left: 0;
      }
      100%{
        left: 15%;
      }
    }
    @keyframes titleGuang2{
      0%{
        right: 0;
      }
      100%{
        right: 15%;
      }
    }
       
  }

  .topContent {
    width: 100%;
    height: 90px;
    position: relative;
     .dh_wz {
    width: 170px;
    height: 47px;
    position: absolute;
    left: 3%;
    top: 20%;
    background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
    background-size: 100% 100%;

    .dh_wz_qq {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      position: absolute;
      top: 6px;
      left: 7px;
      border: 1px solid #ffc600; /* 添加一个黑色的边框 */
      animation: guangying 2s linear infinite;
    }
    .dh_wz_tb {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 15px;
        top: 14px;
        background: url("../assets/img/gbzntyj/nt.png") no-repeat top center;
        background-size: 100% 100%;
        animation: topIcon 2s linear infinite;
        
      }
    .dh_wz_wz {
      width: 120px;
      height: 47px;
      line-height: 47px;
      color: #fff;
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      position: absolute;
      right: 5%;
    }
  }
  .dh_lb {
    // width: 900px;
    height: 45px;
    position: absolute;
    left: 23%;
    top: 20%;
    display: flex;
    flex-flow: row;
    a{
      text-decoration: none;
    }

    .dh_lb_bt {
      width: 124px;
      height: 43px;
      background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #3bf4be;
      transition: all 0.5s ease-out;
    }
    .dh_lb_bt:hover,.dh_lb_bt_cur {
      width: 124px;
      height: 43px;
      cursor: pointer;
      background: url("../assets/img/gbzntyj/xz.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #fff;
    }
  }
    .titleRightImg {
      position: absolute;
      right: 0;
      top: 27%;
      .return {
        width: 77px;
        height: 32px;
        margin-right: 15px;
        cursor: pointer;
        position: relative;
        z-index: 999;
      }
    }
  }
  // 内容
  .content{
    display: flex;
    width: 100%;
    min-height: calc(100vh - 80px);
    box-sizing: border-box;
    padding: 20px 20px 0;
    .left,.right{
      width: 522px;
      display: flex;
      flex-direction: column;
    }
    .center{
      flex: 1;
    }
    .left{
      .table_b{
        width: 92%;
        margin: 0 auto;
       margin-top: 5%;
        height: 100%;
        color: #fff;
        font-size: 14px;
        border-collapse: collapse;
        table-layout: fixed; /* 添加这一句，使表格布局模式为固定 */
        th,
        td {
          border: 1px solid #4FF9F5;
          height: 43px;
          text-align: center;
          white-space: nowrap; /* 防止内容过长时换行，确保列宽一致 */
        }

        th {
          height: 43px;
          font-weight: bold;
          color:#28FCEF ;
        }
      }

        .leftContent1{
          display: flex;
          justify-content: space-between;
          flex:1;
          //padding-bottom: 25px;


          .leftContent1Left{
            width: 250px;
            background: url("../assets/img/plant/imgBg.png") no-repeat top center;
            background-size: 100% 100%;
            margin: 10px 0 10px 10px;
            padding: 8px;
            box-sizing: border-box;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .leftContent1Right{
             width: 218px;
            background: url("../assets/img/plant/leftRightBg.png") no-repeat top center;
            background-size: 100% 100%;
            margin: 10px 10px 10px 0;
            overflow: hidden;
            .leftContent1RightTit{
              font-size: 16px;
              height: 46px;
              line-height: 46px;
              position: relative;
              z-index: 8;
            }
            .textScroll{
              width: 100%;
              // height: 100%;
              font-size: 14px;
              line-height:24px;
              text-align: left;
              padding: 10px;
              box-sizing: border-box;
              // animation: textScroll 4s linear infinite;
              overflow: hidden;
              // border: 1px solid #f00;
            }
          }
        }
        .leftContent2{
          display: flex;
          // height: 250px;
          background: rgba(0,119,129,.2);
          margin: 5px 10px 0;
          justify-content: center;
          .leftContent2Left{
            width: 170px;
            height: 236px;
            background: url("../assets/img/plant/left2Left.png") no-repeat top center;
            background-size: 100% 100%!important;
            margin-right: 20px;
            margin-top: 10px;
            padding: 10px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .leftContent2LeftTit{
              height: 40px;
              font-size: 16px;
              line-height: 40px;
            }
            .leftContent2LeftCon{
              flex: 1;
              position: relative;
              .leftContent2LeftConBg{
                width: 104px;
                height: 104px;
                animation: guangying 2s linear infinite;
                margin-top: 20px;
              }
              .icon{
                position: absolute;
                top:51px;
                left: 34px;
                // animation: jiantou 1s linear infinite;
              }
              // 圆环
              // border: 1px solid;
              // margin: 10px 0 30px;
            }
          }
          .leftContent2Right{
            width: 223px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .leftContent2RightItem{
              width: 223px;
              height: 76px;
              background: url("../assets/img/plant/left2Right.png") no-repeat top center;
              background-size: 100% 100%!important;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 10px;
              .leftContent2RightItemLeft{
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                span{
                  display: block;
                  line-height: 18px;
                }
                span:nth-child(1){
                  font-size: 16px;
                }
                span:nth-child(2){
                  font-size: 12px;
                }
              }
              .icon{
                width: 45px;
                height: 45px;
                margin-right: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                  margin-right: 5px;
                  animation: left2 1s linear infinite;
                }
              }
              
            }
            .leftContent2RightItem:last-child{
              margin-bottom: 10px;
            }
          }
        }
    }
    // 左三
     .leftContent3{
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          padding: 10px 0;
          .leftContent3Item{
            width: 33%;
            display: flex;
            flex-direction: column;
            // justify-content: space-between;
            align-items: center;
            margin: 10px 0;
            .leftContent3Name{
              width: 66px;
                height: 66px;
                position: relative;
              .circle{
                width: 100%;
                height: 100%;
                border:3px solid #0E4743;
                border-radius: 50%;
                text-align: center;
                line-height: 60px;
                font-size: 16px;
              }
              .circle1{
                width: 66px;
                height: 66px;
                border:2px solid #3EFFE1;
                border-radius: 50%;
                text-align: center;
                line-height: 60px;
                position: absolute;
                top: 0;
                left: 0;
              }
              .circle1{
                clip:rect(0,30px,30px,0); 
                animation: guangying 2s linear infinite;
              }
            }
            .leftContent3Value{
                margin-top: 10px;
                font-size: 14px;
              }
          }
           .leftContent3Item:nth-child(even) {
              .circle{
                border:3px solid #2B3852;
              }
              .circle1{
                border:2px solid #663AF7;
              }
            }
    }

    // 右一
    .rightBox1{
        width: 100%;
        height: 350px;
        box-sizing: border-box;
        text-align: center;
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        overflow-x: hidden;
        overflow-y: auto;
        .rightItem1{
          display: flex;
          width: 440px;
          height: 86px;
          margin: 10px 30px;
          background-size:contain!important;
          position: relative;
          // margin-right: 30px;
          .iconBox{
            width: 86px;
            height: 86px;
            background-size:cover!important;
            position: absolute;
            left:20px;
            top: 10px;
            animation: opacity 2s linear infinite;
            animation-delay: 1s;
            .iconBoxBg{
              width: 72px;
              height: 72px;
              background-size:cover!important;
              position: absolute;
              left:7px;
              top: 7px;
              .icon{
                width: 36px;
                height: 40px;
                position: absolute;
                left: 18px;
                top: 16px;
                animation: opacity 1s linear infinite;
               
              }
            }
          }
          .rightItem1Right{
            margin-left: 140px;
            margin-right: 32px;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 15px;
            
            .rightItem1Right1{
              width: 100%;
              display: flex;
              justify-content: space-between;
              line-height: 32px;
              margin-top: 8px;
              .rightItem1Right1Left{
                color: #E3FCE3;
              } 
              .rightItem1Right1Right{
                color: #93E593;
                margin-right: 10px;
                span{
                  font-size: 18px;
                  font-weight: bold;
                  margin-right: 5px;
                }
              }
            }
            .rightItem1Right2{
              width: 100%;
              display: flex;
              justify-content: center;
              margin-top: 6px;
              font-size: 13px;
              .rightItem1Right2Item{
                width: 100%;
                .num{
                  span{
                    font-size: 16px;
                    margin-right: 5px;
                  }
                }
              }
            }
          }
        }
        .rightItem1:nth-child(1){
          background: url("../assets/img/plant/rightItem1.png") no-repeat top right;
          .iconBox{
            background: url("../assets/img/plant/lwq.png") no-repeat;   
            .iconBoxBg{
              background: url("../assets/img/plant/lnq.png") no-repeat;   
            }
          }
        }
        .rightItem1:nth-child(2){
          background: url("../assets/img/plant/rightItem2.png") no-repeat top right;
          .iconBox{
            background: url("../assets/img/plant/cwq.png") no-repeat;
            .iconBoxBg{
              background: url("../assets/img/plant/cnq.png") no-repeat;   
            }  
          }
        }
        .rightItem1:nth-child(3){
          background: url("../assets/img/plant/rightItem3.png") no-repeat top right;
          .iconBox{
            background: url("../assets/img/plant/wql.png") no-repeat;
            .iconBoxBg{
              background: url("../assets/img/plant/nql.png") no-repeat;   
            }  
          }
        }
        .rightJiantou{
          width: 25px;
          height: 19px;
          position: absolute;
          top: 18px;
          right: 0;
          animation: jiantou 1s linear infinite;
        }
    }
    .rightBox1::-webkit-scrollbar,.centerList::-webkit-scrollbar{
      display: none; /* Chrome Safari */
    }
    .line{
      width: 479px;
      height: 5px;
      background: url("../assets/img/plant/x.png") no-repeat;
      position: absolute;
      bottom: 0;
      left: 0;
    }
      //  右二   
     .rightBox2{
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 486px;
      padding:12px 10px;
       .leftBox2Info{
         padding: 43px 30px 60px 18px;
         display: flex;
         flex-direction: column;
         justify-content: space-between;
         .txt1Box{
           .txt1Item{
             background: url("../assets/img/plantfx1/sc.png") no-repeat left 2px;
             padding-left: 30px;
             color: #fff;
             font-size: 16px;
             margin-bottom: 40px;
             text-align: left;
             //font-weight: bold;
             line-height:26px;
           }
         }
         .txt2Box{
           width: 100%;
           height: 74px;
           background: url("../assets/img/plantfx1/tg.png") no-repeat;
           margin-bottom: 30px;
           .txt2Item{
             line-height: 36px;
             font-size: 14px;
             color: #fff;
             text-align: left;
             padding: 0 30px 0 30px;
           }
           .txt2Item:first-child{
             span:last-child{
               color: #1BDDE3;
             }
           }
           .txt2Item:last-child{
             span:last-child{
               color: #BAB350;
             }
           }

         }
       }
      .rightBox2Left{
        width:198px ;
        height: 100%;
        position: relative;
        .leftLine{
          position: absolute;
          width: 21px;
          height: 236px;
          left: 20px;
          top: 10px;
        }
        .rightLine{
          position: absolute;
          width: 21px;
          height: 236px;
          right: 0;
          top: 10px;
          transform: rotate(180deg);
        }
        .centerList{
          height: 90%;
          margin-top: 5%;
          scrollbar-width: none; /* firefox */
          -ms-overflow-style: none; /* IE 10+ */
          overflow-x: hidden;
          overflow-y: auto;
          .centerListItem{
            width: 179px;
            height: 31px;
            line-height: 31px;
            margin: 15px auto;
            text-align: center;
            background: url("../assets/img/plant/right2ListBg.png") no-repeat;
            font-size: 14px;
            text-shadow: 0 2px rgba(0,0,0,.2);
        }
        }  
      }
      .rightBox2Right{
        width: 280px;
        height: 180px;
        background:  url("../assets/img/plant/shipinBg.png") no-repeat center center;
        background-size: 100% 100%!important;
        margin: 40px 15px 0;
        box-sizing: border-box;
        text-align: center;
        .videoBox{
          width: 94%;
          height: 92%;
          margin: 3% 2%;
        }
      }
     } 
  }
}

   .schoolRank{
    height:5rem;
    width:97%;
    margin-left:1%;
    margin-top:.1rem;
    border-radius: 15px;
    border: solid #ccc 1px;
    box-shadow: 0 0 0.266667rem rgba(131, 171, 175, 0.5);
    background-color: #fff;
  .seamless-warp{
    width: 100%;
    height: 5rem;
    overflow: hidden;
    // background-color red
    .rank{
      width: 90%;
      margin-left: 5%;
      line-height: .8rem;
      margin-top: .3rem;
      li{
        height: 1.6rem;
        font-size: 20px;
        margin-left: 10%;
        margin-bottom: 20px;
        // background-color red
        .numbers{
          font-size: 16px;
          color: black;
        .front{
          float: left;
          width: 10%;
          line-height: .8rem;
          margin-left: -10%;
          // background-color skyblue
          }
        }
      }
  }
}
} 
#video .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}

@keyframes textScroll {
    0% {
        transform: translateY(0);
    }
   100% {
        transform: translateY(-100%);
    }
}  
@keyframes flowCss {
      0% {
          /* 移动背景位置 */
          background-position: 0 0;
      }

      100% {
          background-position: -400% 0;
      }
  }

@keyframes bianda {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      transform: scale(0.3);
  } 
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  50%{
    transform: scale(1);
  }
   100%{
    transform: scale(0.3);
  }
}
@keyframes navLine {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                      
      left: 0;
  } 
  50%{                       
      left: 85%;
  }
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  100%{
    left:0
  }
}
@keyframes infoLine {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      
      left: 0;
  } 
  50%{                     
      
      left: 60%;
  }
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  100%{
    left:0
  }
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
  0% {
          transform: rotate(0deg);
      }

  100% {
      transform: rotate(-360deg);
  }
}
/* 定义关键帧 */
@keyframes opacity {    /*引用动画名称*/
  0% {
         filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
      }

  50% {
        filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));
  }
  100% {
         filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
      }
}
@keyframes left2 {    /*引用动画名称*/
  0% {
         filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
         transform: scale(0.8);
         transform: rotate(0);
      }

  50% {
        filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.2));
        transform: scale(1.02);
        transform: rotate(10deg);
  }
  100% {
         filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
         transform: scale(0.9);
         transform: rotate(0);
      }
}
@keyframes jiantou {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      
      right: 0;
      transform: scale(1);
  } 
  50%{                     
      
      right: 5px;
      transform: scale(1.01);
  }
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  100%{
    right: 0;
    transform: scale(1);
  }
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
